import { i18n } from '@/plugins/i18n';
import { common } from '@/helpers/common';

/**
 * Тариф отеля текстом — для буфера обмена.
 * Язык интерфейса, валюта пользователя, ссылок внутри нет.
 *
 * @param hotel отель из выдачи (name, zoneName, countryName, searchData)
 * @param offer выбранный тариф (roomName, boardName, amount, currency)
 * @param params параметры поиска целиком: на детальной странице отеля
 *        searchData приходит урезанным (только даты), а состав туристов
 *        живёт в source маршрута. Даты из searchData важнее — их могли
 *        поменять формой на самой странице.
 */
export const hotelTariffText = (hotel, offer, params = {}) => {
	const search = { ...params, ...(hotel.searchData || {}) };
	const night = search.night || nights(search.dateFrom, search.dateTo);

	const guests = [];
	if (search.adults) {
		guests.push(`${search.adults} ${common.declOfNum(search.adults, i18n.t('account.declOfNum.adults'))}`);
	}
	if (search.childrenCount) {
		guests.push(`${search.childrenCount} ${common.declOfNum(search.childrenCount, i18n.t('account.declOfNum.children'))}`);
	}

	// Строку про гостей пропускаем целиком, если состава нет: пустое место
	// лучше, чем «undefined взрослых» в чужой переписке.
	return [
		`💰 ${i18n.t('account.search.hotels.sorting.price')}: ${common.amount(offer.amount, offer.currency)}`,
		guests.length ? `👤 ${guests.join(', ')}` : null,
		`🏨 ${hotel.name}`,
		`📍 ${[hotel.zoneName, hotel.countryName].filter(Boolean).join(', ')}`,
		`📅 ${search.dateFrom} – ${search.dateTo}, ${night} ${common.declOfNum(night, i18n.t('account.declOfNum.nights'))}`,
		`🛏️ ${offer.roomName}`,
		`🍴 ${offer.boardName}`,
		cancellationLine(offer)
	].filter(Boolean).join('\n');
};

// Правила те же, что в строке тарифа: бесплатно — до первого штрафа,
// невозвратный — первый штраф уже на всю сумму. Политику, которую поставщик
// отдаёт отдельным запросом (reqCanPol), здесь не знаем — строку пропускаем.
const cancellationLine = (offer) => {
	const policies = offer.cancellationPolicies || [];
	if (offer.isFreeCancellation && policies.length) {
		const [date] = String(policies[0].from).split(' ');
		const until = date.split('-').reverse().join('.');
		return `✅ ${i18n.t('account.result.free_cancellation_until')} ${until}`;
	}
	if (!offer.reqCanPol && (!policies.length || policies[0].amount >= offer.amount)) {
		return `⛔ ${i18n.t('account.result.non_refundable')}`;
	}
	return null;
};

const nights = (from, to) => {
	if (!from || !to) return 0;
	return Math.round((new Date(to) - new Date(from)) / 86400000);
};
